import {
  LocalidadRes,
  SolicitudCambioUserReq,
  UserReq,
  UserRes,
} from '../../types/User/types';
import { TrackingRequestBody } from '../../types/Tracking/types';
import { apiRequest } from '../Utils/apiClient';
import {
  GET_LOCALIDADES,
  PERSONAL_DATA,
  SOLICITUD,
  USER_TRACKING,
} from '../Utils/constants';
import { STORAGE_KEYS } from '../../hooks/Auth/useAuth';
import { StorageService } from '../../utils/storage';

const postUser = async (data: UserReq): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('post', PERSONAL_DATA, data);
    return res.success;
  } catch (error) {
    console.error('Error posting user:', error);
    return false;
  }
};

const postSolicitudCambioUser = async (
  data: SolicitudCambioUserReq,
): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('post', SOLICITUD, data);
    return res.success;
  } catch (error) {
    console.error('Error posting solicitud:', error);
    return false;
  }
};

const postTracking = async (body: TrackingRequestBody): Promise<boolean> => {
  try {
    const token = await StorageService.getSecure(STORAGE_KEYS.token);
    if (!token) return false;
    const res = await apiRequest<boolean>('post', USER_TRACKING, body);
    return res.success;
  } catch (error) {
    console.error('Error posting tracking:', error);
    return false;
  }
};

const getUser = (): Promise<UserRes | undefined> =>
  apiRequest<UserRes>('get', PERSONAL_DATA).then((res) => res.data);

const getLocalidades = (provincia: string): Promise<LocalidadRes[] | undefined> =>
  apiRequest<LocalidadRes[]>('post', GET_LOCALIDADES, { provincia }).then(
    (res) => res.data,
  );

const getProvincia = (url: string, localidadId: string): Promise<any | undefined> =>
  apiRequest<any>('get', url, { id: localidadId }).then((res) => res.data);

export {
  postUser,
  postSolicitudCambioUser,
  postTracking,
  getUser,
  getLocalidades,
  getProvincia,
};
